import React, { useEffect, useState } from "react";
import { DialogBox } from "../../shared/components/dialog";
import { DialogContent, FormControl, Stack, TextField, Box } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo, updateLanguage } from "../../redux/features/user.slice";
import { RootStateType } from "../../redux/features/rootSlice";
import useWebSocket from "../../hooks/useWebSocket";
import { webSocketMessage } from "../../config/app";

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  user?: {
    id: string;
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    newpassword: string;
    oldpassword: string;
    preferredlanguages: string;
    timezone: string;
  };
}

const languageOptions = [
  { label: 'English (UK)' },
  { label: 'हिंदी' },
  { label: 'বাংলা' },
  { label: 'English' }
];

const LanguageUpdate = (props: DialogProps) => {
  const { open, onClose, user } = props;
  const dispatch = useDispatch();
  const { updateUserAndNotifyParent } = useWebSocket();
  const languageLoading = useSelector(
    (state: RootStateType) => state.userStateReducer.loading
  );
  const [language, setLanguage] = React.useState<{ label: string } | null>(languageOptions[0]);
  const [buttonEnabled,setButtonEnabled] = useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: { label: string } | null) => {
    setLanguage(newValue);
  };

  const handleListItemClick = async () => {
    // Handle the list item click event here
    const dispatchObj = {
      language: {
        language: language?.label
      },
      callBackSuccess: () => {
        updateUserAndNotifyParent(webSocketMessage.languageResponse);
        onClose();
        dispatch(getUserInfo());
        setButtonEnabled(false);
      },
    };
    dispatch(updateLanguage(dispatchObj));
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      handleListItemClick();
    }
  };

  const dialogClose = () => {
    onClose();
  };
  useEffect(() => {
    if (user?.preferredlanguages) {
      setLanguage({ label: user.preferredlanguages });
    } else {
      setLanguage(null);
    }
  }, [user]);

  useEffect(() => {
    const languageLabel = language?.label;
    const userPreferredLanguage = user?.preferredlanguages;
    const isLanguageValid = languageOptions.some(l => l.label === languageLabel);

    if (!languageLabel || !isLanguageValid || languageLabel === userPreferredLanguage) {
      setButtonEnabled(false);
    } else {
      setButtonEnabled(true);
    }
  }, [language]);
  

  return (
    <>
      <DialogBox
        onClose={dialogClose}
        title={"Update language"}
        buttonText={"Update"}
        buttonClick={handleListItemClick}
        isLoading={languageLoading}
        isBtnEnabled={!buttonEnabled}
        open={open}
        style={{ maxWidth: 500, mx: "auto" }}
      >
        <DialogContent>
          <Stack gap={2}>
            <FormControl size="small" color="secondary">
              <Autocomplete
                id="language-select"
                options={languageOptions}
                value={language}
                onChange={handleChange}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select language"
                    variant="outlined"
                    fullWidth
                    onKeyDown={handleKeyDown}
                    onChange={(e) => {
                      setLanguage({ label: e.target.value});
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.label}
                  </Box>
                )}
              />
            </FormControl>
          </Stack>
        </DialogContent>
      </DialogBox>
    </>
  );
};

export default LanguageUpdate;
